import { useState } from 'react';

export default function HomePage() {
  const [quantity, setQuantity] = useState(10);
  const [cart, setCart] = useState<Array<{id: number, quantity: number, price: number}>>([]);

  const products = [
    { id: 1, name: '10 cartes NFC', quantity: 10, price: 200 },
    { id: 2, name: '20 cartes NFC', quantity: 20, price: 400 },
    { id: 3, name: '50 cartes NFC', quantity: 50, price: 1000 },
    { id: 4, name: '100 cartes NFC', quantity: 100, price: 2000 },
    { id: 5, name: '200 cartes NFC', quantity: 200, price: 4000 },
  ];

  const addToCart = (product: typeof products[0]) => {
    setCart([...cart, { id: product.id, quantity: product.quantity, price: product.price }]);
  };

  const getTotalCart = () => {
    return cart.reduce((sum, item) => sum + item.price, 0);
  };

  const getTotalQuantity = () => {
    return cart.reduce((sum, item) => sum + item.quantity, 0);
  };

  const handleWhatsAppOrder = () => {
    const totalQty = getTotalQuantity();
    const totalPrice = getTotalCart();
    const message = `Bonjour,%0AJe souhaite commander ${totalQty} cartes NFC Avis Google pour un total de ${totalPrice} CHF.%0AMerci de me recontacter pour la suite.`;
    window.open(`https://wa.me/41764165979?text=${message}`, '_blank');
  };

  const handleEmailOrder = () => {
    const totalQty = getTotalQuantity();
    const totalPrice = getTotalCart();
    const subject = 'Commande cartes NFC Avis Google';
    const body = `Bonjour,%0A%0AJe souhaite commander ${totalQty} cartes NFC pour un total de ${totalPrice} CHF.%0AMerci de me contacter pour finaliser la commande.%0A%0ACordialement`;
    window.location.href = `mailto:ireviewlausanne@hotmail.com?subject=${subject}&body=${body}`;
  };

  const scrollToOrder = () => {
    document.getElementById('order-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/067717b96aa4727f5aa47208a466a5d0/8dfc08ce23582ea6a256dc46820c91e3.png" 
                alt="Cartes NFC Avis Google" 
                className="h-20 md:h-32 object-contain max-w-[200px] md:max-w-none"
              />
            </div>
            <div className="flex items-center gap-6">
              <button onClick={scrollToHowItWorks} className="text-gray-700 hover:text-emerald-600 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer">
                Comment ça marche
              </button>
              <button onClick={scrollToOrder} className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 md:px-6 py-2.5 rounded-full font-semibold transition-all hover:scale-105 text-xs md:text-sm whitespace-nowrap cursor-pointer">
                Commander
              </button>
              {cart.length > 0 && (
                <div className="relative">
                  <i className="ri-shopping-cart-line text-2xl text-emerald-600"></i>
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
                    {cart.length}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-40 pb-20 px-6 overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50">
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <h1 className="text-6xl lg:text-7xl font-extrabold text-slate-900 leading-tight">
                Obtenez plus d'avis Google en un simple{' '}
                <span className="relative inline-block">
                  <span className="relative z-10">scan</span>
                  <svg className="absolute -bottom-2 left-0 w-full" height="12" viewBox="0 0 200 12" fill="none">
                    <path d="M2 10C50 5 150 5 198 10" stroke="#FF6B35" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                </span>
              </h1>
              <p className="text-2xl text-gray-600 leading-relaxed font-light">
                Cartes NFC professionnelles pour collecter des avis Google rapidement et améliorer votre visibilité locale.
              </p>
              <div className="flex flex-col gap-4 pt-4">
                <button onClick={scrollToOrder} className="bg-emerald-500 hover:bg-emerald-600 text-white px-10 py-5 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-lg shadow-emerald-500/30 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer">
                  Commander mes cartes
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
                <button onClick={scrollToHowItWorks} className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-10 py-5 rounded-full font-bold text-lg transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer">
                  Voir comment ça marche
                  <i className="ri-play-circle-line text-xl"></i>
                </button>
              </div>
            </div>
            <div className="relative">
              <div className="relative z-10 transform hover:scale-105 transition-transform duration-500">
                <img 
                  src="https://static.readdy.ai/image/067717b96aa4727f5aa47208a466a5d0/41e17a819f6ec02676135c6ec0102eb2.png" 
                  alt="Carte NFC Avis Google" 
                  className="w-full h-auto rounded-3xl shadow-2xl"
                />
              </div>
              <div className="absolute top-10 right-10 animate-bounce">
                <div className="bg-white rounded-2xl shadow-xl p-4 flex items-center gap-2">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-20 px-6 bg-rose-50/50">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-3xl p-12 border-l-8 border-red-500 shadow-lg">
            <h2 className="text-5xl font-bold text-red-600 mb-8 flex items-center gap-3">
              <span>❌</span>
              Vos clients sont satisfaits, mais ne laissent pas d'avis ?
            </h2>
            <div className="grid md:grid-cols-3 gap-6 mt-10">
              <div className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-3xl text-gray-500"></i>
                </div>
                <p className="text-gray-700 font-medium text-lg">Ils oublient</p>
              </div>
              <div className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                  <i className="ri-link-unlink text-3xl text-gray-500"></i>
                </div>
                <p className="text-gray-700 font-medium text-lg">Le lien n'est pas accessible</p>
              </div>
              <div className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                  <i className="ri-hourglass-line text-3xl text-gray-500"></i>
                </div>
                <p className="text-gray-700 font-medium text-lg">C'est trop long</p>
              </div>
            </div>
            <p className="text-center text-xl text-gray-800 mt-10 italic flex items-center justify-center gap-2">
              👉 Résultat : moins de visibilité, moins de clients
              <i className="ri-arrow-down-line text-2xl"></i>
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-slate-900 mb-4 flex items-center justify-center gap-3">
              <span className="text-emerald-500">✅</span>
              La solution simple et moderne
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white border-2 border-gray-100 rounded-2xl p-8 hover:shadow-xl hover:-translate-y-2 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-scan-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Un scan</h3>
              <p className="text-gray-600">Simple et rapide</p>
            </div>
            <div className="bg-white border-2 border-gray-100 rounded-2xl p-8 hover:shadow-xl hover:-translate-y-2 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-download-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Aucun téléchargement</h3>
              <p className="text-gray-600">Pas d'application requise</p>
            </div>
            <div className="bg-white border-2 border-gray-100 rounded-2xl p-8 hover:shadow-xl hover:-translate-y-2 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-smartphone-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Compatible iPhone & Android</h3>
              <p className="text-gray-600">Fonctionne partout</p>
            </div>
            <div className="bg-white border-2 border-gray-100 rounded-2xl p-8 hover:shadow-xl hover:-translate-y-2 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-star-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Avis Google instantané</h3>
              <p className="text-gray-600">Ouverture directe</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-24 px-6 bg-gradient-to-b from-amber-50/30 to-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-20 w-64 h-64 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-orange-400 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-slate-900 mb-4 flex items-center justify-center gap-3">
              <span>⭐</span>
              Ils utilisent nos cartes NFC et obtiennent plus d'avis Google
            </h2>
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mt-4">
              <i className="ri-checkbox-circle-fill"></i>
              Témoignages clients réels
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-3xl p-10 shadow-lg border-2 border-amber-100 hover:shadow-2xl transition-all hover:-translate-y-1">
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-3xl text-yellow-400"></i>
                ))}
              </div>
              <blockquote className="text-xl text-gray-700 leading-relaxed mb-6 relative">
                <span className="absolute -top-4 -left-2 text-6xl text-amber-200 font-serif">"</span>
                <span className="relative z-10">On a doublé le nombre d'avis Google en moins d'un mois. Les clients adorent le côté simple et rapide.</span>
                <span className="absolute -bottom-8 -right-2 text-6xl text-amber-200 font-serif">"</span>
              </blockquote>
              <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
                <div>
                  <p className="text-gray-500 text-sm">Restauration</p>
                </div>
                <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-emerald-600 text-xl"></i>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-10 shadow-lg border-2 border-amber-100 hover:shadow-2xl transition-all hover:-translate-y-1">
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-3xl text-yellow-400"></i>
                ))}
              </div>
              <blockquote className="text-xl text-gray-700 leading-relaxed mb-6 relative">
                <span className="absolute -top-4 -left-2 text-6xl text-amber-200 font-serif">"</span>
                <span className="relative z-10">Avant, presque personne ne laissait d'avis. Depuis la carte NFC, c'est devenu automatique.</span>
                <span className="absolute -bottom-8 -right-2 text-6xl text-amber-200 font-serif">"</span>
              </blockquote>
              <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
                <div>
                  <p className="text-gray-500 text-sm">Coiffure & Beauté</p>
                </div>
                <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-emerald-600 text-xl"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-3xl p-10 shadow-lg border-2 border-amber-100 hover:shadow-2xl transition-all hover:-translate-y-1">
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-3xl text-yellow-400"></i>
                ))}
              </div>
              <blockquote className="text-xl text-gray-700 leading-relaxed mb-6 relative">
                <span className="absolute -top-4 -left-2 text-6xl text-amber-200 font-serif">"</span>
                <span className="relative z-10">Super efficace et très professionnel. La carte est toujours sur le comptoir, les clients scannent sans qu'on leur demande.</span>
                <span className="absolute -bottom-8 -right-2 text-6xl text-amber-200 font-serif">"</span>
              </blockquote>
              <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
                <div>
                  <p className="text-gray-500 text-sm">Automobile</p>
                </div>
                <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-emerald-600 text-xl"></i>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-10 shadow-lg border-2 border-amber-100 hover:shadow-2xl transition-all hover:-translate-y-1">
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-3xl text-yellow-400"></i>
                ))}
              </div>
              <blockquote className="text-xl text-gray-700 leading-relaxed mb-6 relative">
                <span className="absolute -top-4 -left-2 text-6xl text-amber-200 font-serif">"</span>
                <span className="relative z-10">Excellent retour sur investissement. Plus d'avis, plus de visibilité, plus de clients.</span>
                <span className="absolute -bottom-8 -right-2 text-6xl text-amber-200 font-serif">"</span>
              </blockquote>
              <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
                <div>
                  <p className="text-gray-500 text-sm">Commerce de détail</p>
                </div>
                <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-emerald-600 text-xl"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-3 bg-blue-50 px-8 py-4 rounded-full">
              <i className="ri-group-line text-3xl text-blue-600"></i>
              <span className="text-lg font-semibold text-blue-900">Rejoignez +200 professionnels satisfaits</span>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="py-20 px-6 bg-gradient-to-b from-white to-slate-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-slate-900 mb-4">Comment ça marche</h2>
            <p className="text-xl text-gray-600">3 étapes simples pour collecter plus d'avis</p>
          </div>
          <div className="relative">
            <div className="absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-emerald-200 to-blue-200 -translate-y-1/2 hidden lg:block"></div>
            <div className="grid md:grid-cols-3 gap-12 relative z-10">
              <div className="text-center">
                <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
                  <span className="text-4xl font-bold text-white">1</span>
                </div>
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-scan-2-line text-5xl text-blue-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-3">Le client scanne la carte</h3>
                  <p className="text-gray-600">Approche simple du smartphone</p>
                </div>
              </div>
              <div className="text-center">
                <div className="w-24 h-24 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
                  <span className="text-4xl font-bold text-white">2</span>
                </div>
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-google-fill text-5xl text-emerald-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-3">La page Google Avis s'ouvre</h3>
                  <p className="text-gray-600">Automatiquement et instantanément</p>
                </div>
              </div>
              <div className="text-center">
                <div className="w-24 h-24 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
                  <span className="text-4xl font-bold text-white">3</span>
                </div>
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-star-fill text-5xl text-orange-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-3">Il laisse un avis ⭐⭐⭐⭐⭐</h3>
                  <p className="text-gray-600">En quelques secondes</p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-12">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-6 py-3 rounded-full font-bold text-lg">
              <i className="ri-time-line text-2xl"></i>
              Moins de 10 secondes
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-slate-900 mb-4">À qui c'est destiné</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            <div className="text-center group cursor-pointer">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center transition-transform group-hover:scale-110">
                <i className="ri-restaurant-line text-6xl text-red-500"></i>
              </div>
              <p className="font-bold text-lg text-slate-900">Restaurants</p>
            </div>
            <div className="text-center group cursor-pointer">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center transition-transform group-hover:scale-110">
                <i className="ri-scissors-line text-6xl text-pink-500"></i>
              </div>
              <p className="font-bold text-lg text-slate-900">Coiffeurs</p>
            </div>
            <div className="text-center group cursor-pointer">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center transition-transform group-hover:scale-110">
                <i className="ri-car-line text-6xl text-blue-500"></i>
              </div>
              <p className="font-bold text-lg text-slate-900">Garages</p>
            </div>
            <div className="text-center group cursor-pointer">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center transition-transform group-hover:scale-110">
                <i className="ri-store-line text-6xl text-emerald-500"></i>
              </div>
              <p className="font-bold text-lg text-slate-900">Commerces locaux</p>
            </div>
            <div className="text-center group cursor-pointer">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center transition-transform group-hover:scale-110">
                <i className="ri-user-star-line text-6xl text-purple-500"></i>
              </div>
              <p className="font-bold text-lg text-slate-900">Indépendants</p>
            </div>
          </div>
          <div className="text-center mt-16">
            <p className="text-3xl font-bold text-slate-900 bg-yellow-100 inline-block px-8 py-4 rounded-2xl">
              Si vous avez des clients, vous avez besoin d'avis Google
            </p>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="order-section" className="py-24 px-6 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full" style={{backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '30px 30px'}}></div>
        </div>
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-white mb-4">Choisissez votre pack</h2>
            <p className="text-xl text-gray-300">Ajoutez les produits à votre panier</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {products.map((product) => (
              <div key={product.id} className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2">
                <div className="text-center mb-6">
                  <p className="text-5xl font-bold text-slate-900 mb-2">{product.quantity}</p>
                  <p className="text-gray-600 text-lg">cartes NFC</p>
                </div>
                <div className="text-center mb-6">
                  <p className="text-4xl font-bold text-emerald-600">{product.price} CHF</p>
                  <p className="text-gray-500 mt-2">{(product.price / product.quantity).toFixed(0)} CHF / carte</p>
                </div>
                <button
                  onClick={() => addToCart(product)}
                  className="w-full bg-emerald-500 hover:bg-emerald-600 text-white py-4 rounded-full font-bold text-lg transition-all hover:scale-105 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-shopping-cart-line text-xl"></i>
                  Ajouter au panier
                </button>
              </div>
            ))}
          </div>

          {cart.length > 0 && (
            <div className="bg-white rounded-3xl p-8 shadow-2xl">
              <h3 className="text-3xl font-bold text-slate-900 mb-6 text-center">Votre panier</h3>
              <div className="space-y-4 mb-6">
                {cart.map((item, index) => (
                  <div key={index} className="flex items-center justify-between bg-gray-50 rounded-2xl p-4">
                    <div>
                      <p className="font-bold text-lg text-slate-900">{item.quantity} cartes NFC</p>
                    </div>
                    <div className="flex items-center gap-4">
                      <p className="text-2xl font-bold text-emerald-600">{item.price} CHF</p>
                      <button
                        onClick={() => setCart(cart.filter((_, i) => i !== index))}
                        className="w-10 h-10 bg-red-100 hover:bg-red-200 rounded-full flex items-center justify-center cursor-pointer transition-colors"
                      >
                        <i className="ri-delete-bin-line text-red-600"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="border-t-2 border-gray-200 pt-6 mb-6">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-xl font-semibold text-gray-700">Total cartes :</p>
                  <p className="text-2xl font-bold text-slate-900">{getTotalQuantity()}</p>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-xl font-semibold text-gray-700">Total :</p>
                  <p className="text-4xl font-bold text-emerald-600">{getTotalCart()} CHF</p>
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <button
                  onClick={handleWhatsAppOrder}
                  className="bg-green-500 hover:bg-green-600 text-white py-4 rounded-full font-bold text-lg transition-all hover:scale-105 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-2xl"></i>
                  Commander via WhatsApp
                </button>
                <button
                  onClick={handleEmailOrder}
                  className="bg-blue-500 hover:bg-blue-600 text-white py-4 rounded-full font-bold text-lg transition-all hover:scale-105 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-line text-2xl"></i>
                  Commander par Email
                </button>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-smartphone-line text-4xl text-blue-600"></i>
              </div>
              <p className="font-semibold text-slate-900">Compatible iOS & Android</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-flashlight-line text-4xl text-blue-600"></i>
              </div>
              <p className="font-semibold text-slate-900">Activation rapide</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-4xl text-blue-600"></i>
              </div>
              <p className="font-semibold text-slate-900">Utilisé par des professionnels</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-truck-line text-4xl text-blue-600"></i>
              </div>
              <p className="font-semibold text-slate-900">Livraison rapide</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-slate-900 mb-4">Questions fréquentes</h2>
          </div>
          <div className="space-y-4">
            {[
              {
                question: "Est-ce que ça fonctionne avec tous les téléphones ?",
                answer: "Oui, nos cartes NFC sont compatibles avec tous les iPhone (à partir de l'iPhone 7) et les smartphones Android équipés de la technologie NFC."
              },
              {
                question: "Faut-il installer une application ?",
                answer: "Non, aucune application n'est nécessaire. Le scan NFC ouvre directement la page Google Avis dans le navigateur du téléphone."
              },
              {
                question: "Peut-on commander en grande quantité ?",
                answer: "Oui, nous proposons des packs de 10 à 200 cartes. Plus vous commandez, plus le prix par carte diminue."
              },
              {
                question: "Comment se passe le paiement ?",
                answer: "Après avoir ajouté vos produits au panier, contactez-nous via WhatsApp ou Email. Nous finaliserons ensemble les détails de votre commande et du paiement."
              }
            ].map((faq, index) => (
              <details key={index} className="bg-white border-2 border-gray-100 rounded-2xl p-6 hover:shadow-lg hover:border-blue-200 transition-all group">
                <summary className="text-xl font-bold text-slate-900 cursor-pointer flex items-center justify-between">
                  {faq.question}
                  <i className="ri-add-line text-2xl group-open:rotate-45 transition-transform"></i>
                </summary>
                <p className="text-gray-700 mt-4 leading-relaxed">{faq.answer}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-32 px-6 bg-gradient-to-br from-blue-900 via-indigo-900 to-purple-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-96 h-96 bg-blue-500 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-purple-500 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
        </div>
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h2 className="text-6xl font-bold text-white mb-6 leading-tight">
            Rejoignez les professionnels qui collectent plus d'avis Google
          </h2>
          <p className="text-2xl text-white/80 mb-12">
            Augmentez votre visibilité locale et attirez plus de clients
          </p>
          <button onClick={scrollToOrder} className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white px-16 py-6 rounded-full font-bold text-2xl transition-all hover:scale-110 shadow-2xl shadow-emerald-500/50 flex items-center justify-center gap-3 mx-auto whitespace-nowrap cursor-pointer">
            Commander mes cartes NFC
            <i className="ri-arrow-right-line text-3xl"></i>
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-emerald-600 to-teal-700 text-white py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <img 
                src="https://static.readdy.ai/image/067717b96aa4727f5aa47208a466a5d0/8dfc08ce23582ea6a256dc46820c91e3.png" 
                alt="Cartes NFC Avis Google" 
                className="h-16 md:h-20 object-contain max-w-[180px] md:max-w-none mb-4"
              />
              <p className="text-emerald-50">
                La solution professionnelle pour collecter plus d'avis Google
              </p>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-4">Navigation</h3>
              <ul className="space-y-2">
                <li><button onClick={scrollToHowItWorks} className="text-emerald-50 hover:text-white transition-colors cursor-pointer">Comment ça marche</button></li>
                <li><button onClick={scrollToOrder} className="text-emerald-50 hover:text-white transition-colors cursor-pointer">Commander</button></li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-4">Contact</h3>
              <div className="space-y-3">
                <button onClick={handleWhatsAppOrder} className="flex items-center gap-2 text-emerald-50 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line text-xl"></i>
                  076 416 59 79
                </button>
                <button onClick={handleEmailOrder} className="flex items-center gap-2 text-emerald-50 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-mail-line text-xl"></i>
                  ireviewlausanne@hotmail.com
                </button>
              </div>
            </div>
          </div>
          <div className="border-t border-emerald-400/30 pt-8 text-center text-emerald-50">
            <p>&copy; 2025 Cartes NFC Avis Google. Tous droits réservés.</p>
            <p className="mt-2">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
